import { jsx } from "react/jsx-runtime";
import { listClassName } from "@contember/utilities";
const cleanCommonProps = (props) => {
  const {
    className,
    // not listed in commonProps documentation, needs to be removed to allow Emotion to generate classNames
    clearValue,
    cx,
    getStyles,
    getValue,
    hasValue,
    isMulti,
    isRtl,
    options,
    // not listed in commonProps documentation
    selectOption,
    selectProps,
    setValue,
    theme,
    // not listed in commonProps documentation
    ...innerProps
  } = props;
  return { ...innerProps };
};
const SearchInput = (props) => {
  const { innerRef, isDisabled, isHidden, ...innerProps } = cleanCommonProps(props);
  return /* @__PURE__ */ jsx("div", { className: listClassName(["selectField-search", isHidden && "is-hidden"]), "data-value": innerProps.value, children: /* @__PURE__ */ jsx(
    "input",
    {
      type: "text",
      className: "selectField-search-input",
      ref: innerRef,
      disabled: isDisabled,
      ...innerProps
    }
  ) });
};
export {
  SearchInput,
  cleanCommonProps
};
//# sourceMappingURL=SearchInput.js.map
